import inquiries from "./inquiries";
import messages from "./messages";
import setting from "./setting";
import users from "./users";

export default {
    inquiries,
    messages,
    setting,
    users,
};
